import { IDocuGistAnalyticsSearchValueAPI } from '@dealpoint/api-models'
import { IPagedDataResults } from '@dealpoint/deprecated-lib/src/Models'
import { IContractSearchQuery } from '@dealpoint/types'

import { APIClient } from '../../APIClient'
import { IDocumentSearchResponse, ISearchQuery } from '../../types'

export interface PagedSearchPropsObsolete {
  includeIds?: string[]
  matched?: boolean
  page?: number
  pageSize?: number
  searchQuery: ISearchQuery
  url: string
}

export interface IPagedSearchProps {
  includeIds?: string[]
  matched?: boolean
  page?: number
  pageSize?: number
  searchQuery: IContractSearchQuery
  url: string
}

const pagedSearch = async <T = any>({
  includeIds,
  page = 1,
  pageSize = 25,
  searchQuery,
  url,
}: PagedSearchPropsObsolete): Promise<IDocumentSearchResponse<T>> => {
  const { contractTypes, filters, matchedTermTypes, query, ...rest } = searchQuery

  const body: IDocuGistAnalyticsSearchValueAPI = {
    documentIds: includeIds,
    matchedTermTypes,
    searchTerms: filters?.reduce((acc, { searchTerm }) => acc.concat(searchTerm), []),
  }

  const queryParams = {
    page,
    pageSize,
    ...(query && { query }),
    ...(!!contractTypes?.length && { contractTypes: contractTypes.join(',') }),
    ...rest,
  }

  const results = await APIClient.makeAPICall('POST', url, {
    queryParams,
    body,
  })

  return {
    query: searchQuery?.query,
    results: results as IPagedDataResults<T>,
  }
}

export default pagedSearch
